/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useMemo, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import {
  CardMedia,
  Card,
  CardHeader,
  CardContent,
  Stack,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import { Grid, Paper, Select } from "@mui/material";
import { styled } from "@mui/material/styles";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import TbBookingStatus from "./TbBookingStatus";
import TbSelectTestDateAndTime from "./TbSelectTestDateAndTime";
import TbCheckingBookingData from "./TbCheckingBookingData";
import {
  rankarr,
  perscorpsarr,
  persgrpsarr,
  rtafunitarr,
} from "./GlobalUseData";
/*------------------ Redux ---------------------*/
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMemberInfoByPersId,
  fetchMemberInfoByName,
  fetchAllMemberInfoByName,
} from "../store/MemberInfoSlice";
import OwnToastContentWithTxtInput from "./OwnToastContentWithTxtInput";

/*------------------- Style --------------------------*/
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#FFF",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  //textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "THSarabunNew",
      fontSize: 14,
    },
  },

  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          backgroundColor: grey["200"],
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          height: 30,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: 30,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          height: 30,
        },
      },
    },
  },
});

/*------------------------------ ContentTapOne -------------------------------------*/
function ContentTapOne(props) {
  /*----------------------------- Show/Hide Checking Panel -----------------*/
  const [checkingpanel, setHideCheckingPanel] = useState(false);

  /*----------------------------- candidate list ---------------------------*/

  const [persidValue, setPersIdValue] = useState("");
  const [persNameValue, setPersNameValue] = useState("");
  const [persPositionValue, setPersPositionValue] = useState("");
  const [persCellPhone, setPersCellPhone] = useState("");
  const [persOffTel, setPersOffTel] = useState("");
  const [persEmail, setPersEmail] = useState("");

  //const [imgpath, setImgPath] = useState('');

  /*----------------- all members added on 11-09-2024 -------------------*/

  const allmbrdispatch = useDispatch();
  const [mbrlist, setMbrList] = useState([]);
  const autocompleteoptions = {
    options: !mbrlist
      ? []
      : mbrlist.map((mbr) => mbr.mem_fname + " " + mbr.mem_lname),
    getOptionLabel: (option) => option,
  };

  /*------------------------- Image From HRIS : updated on 10-09-2567 --------------*/
  const [imgloading, setImgLoading] = useState(false);
  const [openImgPanel, setOpenImgPanel] = useState(false);
  const [imagesString, setImagesString] = useState("");
  let imgBlobSrc = null;

  const getBase64Image = async (res) => {
    const blob = await res.blob();
    const reader = new FileReader();
    await new Promise((resolve, reject) => {
      reader.onload = resolve;
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    /*****************  added on 04-10-2024 **************************/

    function isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
    imgBlobSrc = isJsonString(await blob.text())
      ? JSON.parse(await blob.text())
      : await blob.text();
    if (typeof imgBlobSrc !== "string") {
      setImgLoading(false);
    }
    /*--------------------------------------------------------------*/
    return reader.result;
  };

  const handleOpenImgPanel = async () => {
    setImgLoading(true);
    const token = localStorage.getItem("token");

    await fetch(
      `${process.env.REACT_APP_API_URL}/pagebookdate/previmgfileformhris/pers_id/${persidValue}`,
      {
        headers: {
          authtoken: `Bearer ${token}`,
        },
      }
    )
      .then(getBase64Image)
      .then((imgString) => setImagesString(imgString))
      .then(() => {
        //setImgLoading(true);
        setOpenImgPanel(true);
      });
  };
  const handleCloseImgPanel = () => setOpenImgPanel(false);

  /*----------------------------- data selection -------------------------*/
  const [rank, setRank] = useState(0);
  const [perscorps, setPersCorps] = useState(0);
  const [persgrps, setPersGrps] = useState(0);
  const [rtafunit, setRtafUnit] = useState(0);

  /*---------------------------------- date -----------------------------*/
  const [newdate, setNewDate] = useState(props.date);
  const updateddate = useMemo(() => newdate, [newdate]);

  /*------------------------ Func : setInitialValue --------------------*/
  const setInitBySearchFieldOnClick = () => {
    setHideCheckingPanel(false);
    setRank(0);
    setPersCorps(0);
    setPersGrps(0);
    setRtafUnit(0);
    setPersIdValue("");
    setPersNameValue("");
    setPersPositionValue("");
    setPersCellPhone("");
    setPersOffTel("");
    setPersEmail("");
    // setImgPath('');
  };

  /*----------------------- Redux : useEffect --------------------------*/
  const meminfolist = useSelector((state) => {
    if (persidValue !== "" && persNameValue !== "") {
      return state.memberinfostate.meminfoarr;
    }
    return null;
  });
  const meminfodispatch = useDispatch();

  /*-------------------------- search func ------------------------------*/
  const setFoundMemInfo = (res) => {
    setRank(rankarr.indexOf(res.rank));
    setPersCorps(perscorpsarr.indexOf(res.branch));
    setPersGrps(persgrpsarr.indexOf(res.branchgrp));
    setRtafUnit(Object.keys(rtafunitarr).indexOf(res.affiliation));
    setPersIdValue(res.pers_id);
    setPersNameValue(res.name);
    setPersPositionValue(res.position);
    setPersCellPhone(res.cellphone);
    setPersOffTel(res.offtel);
    setPersEmail(res.email);
    // setImgPath(res.image);
  };

  const persIdSearchOnClick = useCallback(() => {
    if (persidValue?.length === 13) {
      meminfodispatch(fetchMemberInfoByPersId({ pers_id: persidValue }))
        .then((res) => {
          if (res.payload.length === 0) {
            setSnackOpen(true);
          } else {
            setFoundMemInfo(res.payload);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      toast("กรุณากรอกเลขประจำตัวประชาชนให้ครบ ๑๓ หลัก", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }, [persidValue, meminfodispatch]);

  const persNameSearchOnClick = useCallback(() => {
    if (persNameValue?.length > 0) {
      meminfodispatch(
        fetchMemberInfoByName({
          pers_name: persNameValue.length === 0 ? "''" : persNameValue,
        })
      )
        .then((res) => {
          if (res.payload.length === 0) {
            setSnackOpen(true);
          } else {
            setFoundMemInfo(res.payload);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      toast("กรุณาตรวจสอบความถูกต้องของรายชื่อที่กรอก", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }, [persNameValue, meminfodispatch]);

  /*---------------------- Snackbar : add 03-05-2024 -----------------------*/
  const [snackopen, setSnackOpen] = useState(false);
  const handleSnackbarOnClose = () => {
    setSnackOpen(false);
  };

  /********************* updated on 17-09-2024 *****************************/
  const mbrUpdateFunc = useCallback(
    (persid) => {
      meminfodispatch(fetchMemberInfoByPersId({ pers_id: persid }))
        .then((res) => {
          if (res.payload.length !== 0) {
            setFoundMemInfo(res.payload);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    [snackopen, meminfodispatch]
  );
  /*----------------------------------- Return --------------------------*/
  return (
    <ThemeProvider theme={theme}>
      <Stack spacing={4} sx={{ padding: 4 }}>
        <Item>
          <Stack direction={"row"} spacing={2}>
            <Item>
              <Grid
                container
                columnSpacing={1}
                rowSpacing={1}
                //sx={{ border: '4px solid green' }}
              >
                <Grid
                  item
                  xs={12}
                  sx={{
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  ข้อมูลบุคคล
                </Grid>
                <Grid item xs={12}></Grid>
                <Grid
                  item
                  xs={3}
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  เลขประจำตัวประชาชน:
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    inputProps={{ maxLength: 13 }}
                    value={persidValue}
                    onChange={(evt) => {
                      setPersIdValue(evt.target.value);
                    }}
                    onClick={() => {
                      setInitBySearchFieldOnClick();
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      persIdSearchOnClick();
                    }}
                  >
                    ค้นหา
                  </Button>
                  <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    open={snackopen}
                    autoHideDuration={5000}
                    onClose={handleSnackbarOnClose}
                    message="test"
                    action={
                      <OwnToastContentWithTxtInput
                        persid={persidValue}
                        contents={
                          `ไม่พบข้อมูล กรุณาป้อนเลขประจำตัวข้าราชการ เพื่อตรวจสอบข้อมูลกับระบบ HRIS` //***** updated on 17-09-2024
                        }
                        openFunc={setSnackOpen}
                        mbrUpdateFunc={mbrUpdateFunc}
                        //toastId={t.toastProps.toastId}
                      />
                    }
                    ContentProps={{
                      sx: {
                        bgcolor: "white",
                        padding: "20px",
                      },
                    }}
                  />
                </Grid>
                {/* <Grid item xs={3}></Grid> */}

                <Grid
                  item
                  xs={3}
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  ชื่อ:
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    {...autocompleteoptions}
                    value={persNameValue}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    noOptionsText={"ไม่พบข้อมูลที่ต้องการ"}
                    onChange={(event, value, reason) => {
                      //console.log('reason --->', reason);
                      if (reason !== "clear") {
                        setPersNameValue(value);
                      } else {
                        setInitBySearchFieldOnClick();
                      }
                    }}
                    onInputChange={(event, value) => {
                      if (value.length !== 0) {
                        allmbrdispatch(fetchAllMemberInfoByName(value))
                          .then((res) => {
                            let unique = res.payload;
                            unique = unique.reduce((a, b) => {
                              if (
                                !a.find(
                                  (item) =>
                                    item.mem_fname === b.mem_fname &&
                                    item.mem_lname === b.mem_lname
                                )
                              ) {
                                a.push(b);
                              }
                              return a;
                            }, []);
                            setMbrList(unique);
                          })
                          .catch((err) => {
                            console.error(err);
                          });
                      } else {
                        setMbrList([]);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        onChange={(event) => {
                          setPersNameValue(event.target.value);
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      persNameSearchOnClick();
                    }}
                  >
                    ค้นหา
                  </Button>
                </Grid>

                <Grid
                  item
                  xs={3}
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  ตำแหน่ง:
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    value={persPositionValue}
                    onChange={(evt) => {
                      setPersPositionValue(evt.target.value);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={3}
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  ยศ:
                </Grid>
                <Grid item xs={3}>
                  <Select
                    value={rank}
                    fullWidth
                    onChange={(newRank) => {
                      setRank(newRank.target.value);
                    }}
                  >
                    {rankarr.map((rnk, i) => {
                      return (
                        <MenuItem key={i} value={i}>
                          {rnk}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>

                <Grid
                  item
                  xs={3}
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  เหล่า:
                </Grid>
                <Grid item xs={3}>
                  <Select
                    value={perscorps}
                    fullWidth
                    onChange={(newRank) => {
                      setPersCorps(newRank.target.value);
                    }}
                  >
                    {perscorpsarr.map((rnk, i) => {
                      return (
                        <MenuItem key={i} value={i}>
                          {rnk}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>
                <Grid
                  item
                  xs={3}
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  จำพวก:
                </Grid>
                <Grid item xs={3}>
                  <Select
                    value={persgrps}
                    fullWidth
                    onChange={(newRank) => {
                      setPersGrps(newRank.target.value);
                    }}
                  >
                    {persgrpsarr.map((rnk, i) => {
                      return (
                        <MenuItem key={i} value={i}>
                          {rnk}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>

                <Grid
                  item
                  xs={3}
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  สังกัด:
                </Grid>
                <Grid item xs={3}>
                  <Select
                    value={rtafunit}
                    fullWidth
                    onChange={(newRank) => {
                      setRtafUnit(newRank.target.value);
                    }}
                  >
                    {Object.keys(rtafunitarr).map((rnk, i) => {
                      return (
                        <MenuItem key={i} value={i}>
                          {rnk}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>
                <Grid
                  item
                  xs={3}
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  รูปถ่าย:
                </Grid>
                <Grid item xs={3}>
                  <div>
                    <Button
                      variant="outlined"
                      sx={{ width: "100%" }}
                      onClick={handleOpenImgPanel}
                      disabled={meminfolist === null ? true : false} //--> added : 14-05-2024
                    >
                      แสดงรูปภาพ
                    </Button>
                    <Modal
                      open={openImgPanel}
                      onClose={handleCloseImgPanel}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Card sx={{ maxWidth: 500 }}>
                        <CardHeader
                          sx={{ textAlign: "center" }}
                          titleTypographyProps={{
                            variant: "caption",
                          }}
                          title={`เลขประจำตัวประชาชน: ${persidValue}`}
                          subheaderTypographyProps={{
                            variant: "caption",
                            fontWeight: "bold",
                          }}
                          subheader={`ยศ-ชื่อ-นามสกุล: ${meminfolist?.rank} ${persNameValue}`}
                        />
                        <CardContent>
                          <CardMedia
                            component="img"
                            // src={
                            //   persidValue
                            //     ? `${process.env.REACT_APP_API_URL}/pagebookdate/previmgfileformhris/pers_id/${persidValue}`
                            //     : "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
                            // }
                            src={imagesString}
                            alt={
                              typeof imgBlobSrc !== "string"
                                ? "ไม่พบรูปถ่ายของข้าราชการในระบบ HRIS"
                                : ""
                            } //---> updated on 04-10-2024
                            style={{
                              height: 450,
                            }}
                            onLoad={() => {
                              setImgLoading(false);
                            }}
                          />
                        </CardContent>
                      </Card>
                    </Modal>
                  </div>
                </Grid>

                <Grid
                  item
                  xs={3}
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  เบอร์มือถือ:
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    inputProps={{ maxLength: 10 }}
                    value={persCellPhone}
                    onChange={(evt) => {
                      setPersCellPhone(evt.target.value);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={3}
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  เบอร์ที่ทำงาน:
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    inputProps={{ maxLength: 5 }}
                    value={persOffTel}
                    onChange={(evt) => {
                      setPersOffTel(evt.target.value);
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={3}
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  E-mail:
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    value={persEmail}
                    onChange={(evt) => {
                      setPersEmail(evt.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={6}></Grid>
              </Grid>
            </Item>
            <Item>
              <TbBookingStatus date={updateddate /*newdate*/} />
            </Item>
          </Stack>
        </Item>
        {
          //-------------> updated on 11-09-2024
          imgloading && (
            <Item
              elevation={0}
              style={{
                justifyContent: "center",
                display: "inline-flex",
                backgroundColor: "transparent",
              }}
            >
              <div style={{ position: "relative" }}>
                <span
                  style={{ position: "absolute", top: "40px", left: "22px" }}
                >
                  รอสักครู่
                </span>
                <CircularProgress size={100} />
              </div>
            </Item>
          )
        }
        <Item>
          <TbSelectTestDateAndTime
            date={updateddate}
            checkpanelstate={checkingpanel}
            tabclosefunc={props.tabclosefunc}
            hidecheckingpanelfunc={setHideCheckingPanel}
            newdatefunc={setNewDate}
            meminfolist={meminfolist}
          />
        </Item>
        <Item>
          {checkingpanel && (
            <TbCheckingBookingData
              checkpanelstate={checkingpanel}
              tabclosefunc={props.tabclosefunc} //---> added on 04-10-2024
              hidecheckingpanelfunc={setHideCheckingPanel}
            />
          )}
        </Item>
      </Stack>
    </ThemeProvider>
  );
}

export default ContentTapOne;
